import type { TypeVisibilitySettingsWithoutUnresolvableLinksResponse } from '@/types/contentful/TypeVisibilitySettings'
import type { VisibilityDecision } from '~/types/visibility'
import { evaluateVisibilityDecision } from '~/utils/visibilityDecision'

export default defineNuxtPlugin(() => {
  const evaluateVisibility = (
    visibility:
      | TypeVisibilitySettingsWithoutUnresolvableLinksResponse
      | undefined
      | null,
    options?: {
      debug?: boolean
    },
  ): VisibilityDecision => {
    const nuxtApp = useNuxtApp()
    const { locale } = nuxtApp.$i18n
    const { highestUserLevel, stores, loggedIn } = storeToRefs(useUserStore())

    const visitorCountry = useCookie<string>('visitor_country')
    const countryCookie = visitorCountry.value?.trim?.() || ''

    return evaluateVisibilityDecision({
      visibility,
      loggedIn: loggedIn.value,
      highestUserLevel: highestUserLevel.value,
      stores: stores.value,
      country: countryCookie,
      locale: locale.value,
      debug: options?.debug === true,
      userAccessCheck: nuxtApp.$userAccessCheck,
    })
  }

  // boolean wrapper kept for entry-filtering callers
  const visibility = (
    visibility:
      | TypeVisibilitySettingsWithoutUnresolvableLinksResponse
      | undefined
      | null,
    options?: {
      debug?: boolean
    },
  ): boolean | null => {
    return evaluateVisibility(visibility, options).visible
  }

  return {
    provide: {
      visibility,
      visibilityDecision: evaluateVisibility,
    },
  }
})
